@if (item.url) {
  <a [ngClass]="getItemClass()"
    href="{{item.url}}"
    [appHtmlAttr]="item.attributes">
    <sidebar-nav-icon-img [item]="item"></sidebar-nav-icon-img>
    <ng-container>{{item | translate_menu | async}}</ng-container>
    @if (helper.hasBadge(item)) {
      <span [ngClass]="item | appSidebarNavBadge">{{ item.badge.text }}</span>
    }
  </a>
}

@if (!item.url) {
  <a [ngClass]="getItemClass()"
    href=" javascript:void(0)"
    [appHtmlAttr]="item.attributes">
    <sidebar-nav-icon-img [item]="item"></sidebar-nav-icon-img>
    <ng-container>{{item | translate_menu | async}}</ng-container>
    @if (helper.hasBadge(item)) {
      <span [ngClass]="item | appSidebarNavBadge">{{ item.badge.text }}</span>
    }
  </a>
}
